import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../store/actions/index";

import Breadcrumb from "../components/Breadcrumb";
import FormOne from "../components/HmgCreate/FormOne";

import { Steps } from "antd";
const moment = require("moment");
const { Step } = Steps;

class HmgCreate extends Component {
  formOneFormRef = React.createRef();
  state = {
    current: 0,
    create: true,
    select: null,
    selectData: null,
    finish: false,
  };

  async componentDidMount() {
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (!this.props.api.indexesGetData) {
      await this.props.indexesGet();
    }
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    if (!this.props.api.applicationsGetData) {
      await this.props.applicationsGet();
    }
    await this.props.solutionsGet();
  }

  customFormRest = () => {
    this.formOneFormRef.current.setFieldsValue({
      smart_scaning_timed_out: null,
      // project_name_1: "",
      signature_type: undefined,
      solution: undefined,
      smart_scan_type: undefined,
      split_by_sub_header: "2",
      applications: undefined
    });

  };

  excludeReset = () => {
    const fieldsToExclude = ['hmg_id', 'project_name_1', 'project_name', 'solution'];
    const fieldValues = this.formOneFormRef.current.getFieldsValue();
    const fieldsToReset = Object.keys(fieldValues).filter(
      fieldName => !fieldsToExclude.includes(fieldName)
    );
    this.formOneFormRef.current.resetFields(fieldsToReset);
  };

  // solutionOnChange = (value) => {

  // }

  FormOneOnFinish = async (values) => {
    if (this.state.create) {
      if (await this.props.hmgCreate(values)) {
        // form.resetFields();
        await this.props.hmgGet();
        await this.props.hmgMainGet();
        this.formOneFormRef.current.resetFields();
        this.customFormRest();
        this.setState({ current: 0, finish: true });
      }
    } else {
      if (await this.props.hmgUpdate(values)) {
        // form.resetFields();
        await this.props.hmgGet();
        this.formOneFormRef.current.resetFields();
        this.customFormRest();
        this.setState({ current: 0 });
      }
    }
  };

  autoCompleteOneChangeFunction = async (value, value2) => {
    if (value === undefined) {
      value = "";
    }
    if (value2 === undefined) {
      value2 = "";
    }
    this.setState({ finish: false });
    const result = this.props.api.hmgGetData.data.find(
      (e) =>
        e.project_name.toUpperCase() === value.toUpperCase() &&
        e.hmg_id.toString() === value2.toString()
    );
    if (result) {
      this.formOneFormRef.current.resetFields(["custom", "custom2"]);
      await this.setState({ create: false, selectData: result });

      // if (this.formFirstStepFormRef && this.formFirstStepFormRef.props) {
      let initialValue = null;
      if (this.state.selectData) {
        initialValue = this.state.selectData;
      }

      this.formOneFormRef.current.setFieldsValue({
        _id: initialValue && initialValue._id ? initialValue._id : null,
        project_name:
          initialValue && initialValue.project_name
            ? initialValue.project_name
            : null,
        project_id:
          initialValue && initialValue.project_id
            ? initialValue.project_id
            : null,
        hmg_id:
          initialValue && initialValue.hmg_id ? initialValue.hmg_id : null,

        index_id:
          initialValue && initialValue.index_id ? initialValue.index_id : [],

        solution:
          initialValue && initialValue.solution
            ? initialValue.solution
            : undefined,
        smart_scan_type:
          initialValue && initialValue.smart_scan_type
            ? initialValue.smart_scan_type
            : undefined,
        split_by_sub_header:
          initialValue && initialValue.split_by_sub_header
            ? initialValue.split_by_sub_header
            : "2",
        signature_type:
          initialValue && initialValue.signature_type
            ? initialValue.signature_type
            : undefined,
        smart_scaning_timed_out:
          initialValue && initialValue.smart_scaning_timed_out
            ? moment(initialValue.smart_scaning_timed_out, "HH:mm")
            : null,
        finance_checklist: initialValue?.finance_checklist ?? false,
        applications: undefined,
      });
    } else {
      this.setState({ create: true, selectData: null });
      this.formOneFormRef.current.resetFields([
        "project_id",
        "signature_type",
        "smart_scaning_timed_out",
        "solution",
        "finance_checklist",
        "applications",
        "custom",
        "smart_scan_type",
        "split_by_sub_header",
      ]);
      this.customFormRest();

      this.formOneFormRef.current.setFieldsValue({
        project_name: value,
      });
    }
  };

  projectName1AutoCompleteOnChangeFunction = async (value1, value2) => {
    await this.autoCompleteOneChangeFunction(value1, value2);
  };

  next = async () => {
    try {
      await this.formOneFormRef.current.validateFields();
      const current = this.state.current + 1;
      this.setState({ current });
    } catch (e) {
      console.log(e, "err");
    }
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };
  render() {
    const { current } = this.state;
    const steps = [
      {
        title: "GENERAL INFORMATION",
        content: "First-content",
      },
      {
        title: "INDEXES",
        content: "Second-content",
      },
      {
        title: "INDEX ORDER",
        content: "third-content",
      },
    ];

    return (
      <div>
        <div className="container_aa">
          <h3>Project Create and Update</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "project-create",
                breadcrumbName: "Project Create and Update",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_2">
            <div>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>

              <div style={{ marginBottom: 20 }}></div>

              <div className="steps-content">
                {this.props.api.hmgGetData &&
                  this.props.api.hmgMainGetData &&
                  this.props.api.applicationsGetData &&
                  this.props.api.indexesGetData &&
                  this.props.api.solutionsGetData ? (
                  <FormOne
                    formRef={this.formOneFormRef}
                    onFinish={this.FormOneOnFinish}
                    hmgGetData={this.props.api.hmgGetData.data}
                    hmgMainGetData={this.props.api.hmgMainGetData.data}
                    indexesGetData={this.props.api.indexesGetData.data}
                    solutionsGetData={this.props.api.solutionsGetData.data}
                    applicationsGetData={
                      this.props.api.applicationsGetData.data
                    }
                    projectName1AutoCompleteOnChangeFunction={
                      this.projectName1AutoCompleteOnChangeFunction
                    }
                    createStatus={this.state.create}
                    current={current}
                    next={this.next}
                    prev={this.prev}
                    steps={steps}
                    initialValue={this.state.selectData}
                    finish={this.state.finish}
                    solutionOnChange={this.solutionOnChange}
                    excludeReset={this.excludeReset}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  indexesGet: () => dispatch(actions.indexesGet()),
  applicationsGet: () => dispatch(actions.applicationsGet()),
  solutionsGet: () => dispatch(actions.solutionsGet()),
  hmgCreate: (data) => dispatch(actions.hmgCreate(data)),
  hmgUpdate: (data) => dispatch(actions.hmgUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HmgCreate);
